import { render, staticRenderFns } from "./CheckIconLg.vue?vue&type=template&id=4867a49e&scoped=true&"
import script from "./CheckIconLg.vue?vue&type=script&lang=js&"
export * from "./CheckIconLg.vue?vue&type=script&lang=js&"
import style0 from "./CheckIconLg.vue?vue&type=style&index=0&id=4867a49e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4867a49e",
  null
  
)

export default component.exports